import React from 'react';
import {Button} from '@material-ui/core';
import {TimespanCategory} from '@pluto/rest';

import {MarkupMarker} from 'VideoAudioQC/Timeline/TimelineTypes';
import {Item} from 'VideoAudioQC/QCMedia/Redux/QCMediaActions';
import {MarkupData} from 'VideoAudioQC/QCTabs/Markup/Table/Table';
import {curry} from 'ramda';
import {OnMouseDivEvent} from '@pluto/@types';
import TableContainer, {
    OnButtonClick,
    OnEditMarkupMarker,
} from './Table/TableContainer';

import './Markup.scss';

type OnClickOutsideList = () => void;

export interface MarkupProps {
    item: Item;
    markers: MarkupMarker[];
    selectedMarkerId: string;
    noteTypes: TimespanCategory[];
    onCreateMarker: () => void;
    onMarkerClick: (marker: MarkupData) => void;
    onDeleteClick: OnButtonClick;
    onEditMarker: OnEditMarkupMarker;
    onClickOutsideList: OnClickOutsideList;
    jobDeliveryDate: string;
}

export const onClickOnContainer = curry((onClickOutsideList: OnClickOutsideList, event: OnMouseDivEvent) => {
    event.stopPropagation();
    
    onClickOutsideList();
});

export const createMarker = curry((onCreateMarker: () => void, event: OnMouseDivEvent) => {
    event.stopPropagation();
    
    onCreateMarker();
});

export default function Markup(props: MarkupProps) {
    const {
        item,
        markers,
        noteTypes,
        selectedMarkerId,
        onCreateMarker,
        onMarkerClick,
        onDeleteClick,
        onEditMarker,
        onClickOutsideList,
        jobDeliveryDate,
    } = props;
    const {
        frameRate,
        dropFrame,
        duration,
    } = item.video;
    
    const handleClickOutsideList = onClickOnContainer(onClickOutsideList);
    const handleCreateMarker = createMarker(onCreateMarker);
    
    return (
        <div
            className="markup-root"
            aria-hidden="true"
            onClick={handleClickOutsideList}
        >
            <div
                className="button-container"
                aria-hidden="true"
                onClick={handleClickOutsideList}
            >
                <Button
                    onClick={handleCreateMarker}
                    variant="outlined"
                    color="primary"
                    size="small"
                    disabled={Boolean(jobDeliveryDate)}
                >
                    Add Markup
                </Button>
            </div>
            <TableContainer
                jobDeliveryDate={jobDeliveryDate}
                markers={markers}
                noteTypes={noteTypes}
                selectedMarkerId={selectedMarkerId}
                frameRate={frameRate}
                dropFrame={dropFrame}
                duration={duration}
                onMarkerClick={onMarkerClick}
                onDeleteClick={onDeleteClick}
                onEditMarker={onEditMarker}
            />
        </div>
    );
}
